import React from 'react';

export default function CompanyNavSection({ id, label, icon, expanded, active, onToggle, children }) {
  const panelId = `company-nav-${id}`;
  return <div style={{marginBottom:3}}>
    <button type="button" className={`company-nav-item admin-nav-item ${active && !expanded ? 'active' : ''}`} aria-expanded={expanded} aria-controls={panelId} onClick={onToggle}
      style={{width:'100%',display:'flex',alignItems:'center',justifyContent:'space-between',gap:8,fontWeight:800,color:active?'#0f766e':'#334155',background:expanded?'#f1f5f9':undefined}}>
      <span style={{display:'flex',alignItems:'center',gap:12}}><span className="company-nav-icon" aria-hidden="true">{icon}</span><span>{label}</span></span>
      <span aria-hidden="true" style={{fontSize:12,color:'#64748b',transform:expanded?'rotate(90deg)':'none',transition:'transform .15s'}}>›</span>
    </button>
    <div id={panelId} hidden={!expanded} style={{display:expanded?'flex':'none',flexDirection:'column',margin:'3px 0 7px 10px',paddingLeft:6,borderLeft:'1px solid #e2e8f0'}}>
      {React.Children.map(children, child => {
        if (!React.isValidElement(child) || child.type !== 'button') return child;
        const parts = React.Children.toArray(child.props.children);
        const textOf = part => React.isValidElement(part) ? React.Children.toArray(part.props.children).map(textOf).join('') : String(part ?? '');
        const label = parts.filter(part => !React.isValidElement(part) || part.props.className !== 'company-nav-icon').map(textOf).join('').trim();
        return React.cloneElement(child, { title: child.props.title || label },
          parts.map((part, index) => typeof part === 'string' || typeof part === 'number'
            ? <span key={index} className="company-nav-label">{part}</span>
            : React.isValidElement(part) && !part.props.className
              ? React.cloneElement(part, { className: 'company-nav-label' })
              : part));
      })}
    </div>
  </div>;
}

export function sidebarGroupFor(nav) {
  return ({profile:'settings',salary_structure:'settings',employees:'employees',joining_kit:'employees',attendance:'attendance',leave_management:'attendance',payroll:'payroll',reports:'reports',org:'people',recruitment:'people',offboarding:'people'})[nav] || null;
}
